import React, { useState, useEffect } from 'react';
import { VOTER_ORANGE, voterIcons } from '../../component/voterCardIcons';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import '../../style/speakSearch.css';
import Header from '../../component/header';
import WhatsappSlipButton from '../../component/WhatsappSlipButton';
import PracharButton from '../../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const DateWiseCallCenterSurveyMember = () => {
    // --- State ---
    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [showDropdown, setShowDropdown] = useState(false);

    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    // --- Hooks & Context ---
    const navigate = useNavigate();
    const location = useLocation();
    const { appId, language, userId } = useAppId();
    const lang = language || 'en';

    // Retrieve formatted date from router state (e.g., "30,MAR,2026")
    const passedDate = location.state?.date || "";

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "Surveyed Voters",
            subtitlePrefix: "Voters surveyed on:",
            searchPlaceholder: "Search voter by name or mobile...",
            loadingData: "Loading Data...",
            noData: "No voters found matching",

            // Labels
            fatherHusband: "F/H :",
            serialNumber: "Sr No. :",
            mobile: "Mobile :",
            idCard: "ID Card :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLocation: "Voting Loc :",
            note: "Note :",
            n_a: "N/A",

            // Statuses & Filter
            filterByStatus: "Filter by Status",
            allStatuses: "All",
            positive: "Positive",
            negative: "Negative",
            doubtful: "Doubtful",
            cantSay: "Can't Say",
            notReceived: "Not Received",
            wrongMobile: "Wrong Mobile",

            // Actions
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            address: "Address",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!"

        },
        hi: {
            pageTitle: "सर्वेक्षित मतदाता",
            subtitlePrefix: "इस तिथि पर सर्वेक्षित मतदाता:",
            searchPlaceholder: "नाम या मोबाइल से खोजें...",
            loadingData: "डेटा लोड हो रहा है...",
            noData: "कोई मतदाता नहीं मिला",

            fatherHusband: "पिता/पति :",
            serialNumber: "क्रमांक :",
            mobile: "मोबाइल :",
            idCard: "पहचान पत्र :",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLocation: "मतदान स्थान :",
            note: "नोट :",
            n_a: "N/A",

            filterByStatus: "स्थिति के अनुसार फ़िल्टर करें",
            allStatuses: "सभी",
            positive: "सकारात्मक",
            negative: "नकारात्मक",
            doubtful: "संदिग्ध",
            cantSay: "कह नहीं सकते",
            notReceived: "प्राप्त नहीं",
            wrongMobile: "गलत मोबाइल",

            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"

        },
        gu: {
            pageTitle: "સર્વેક્ષણ કરેલ મતદારો",
            subtitlePrefix: "આ તારીખે સર્વેક્ષણ કરેલ મતદારો:",
            searchPlaceholder: "નામ અથવા મોબાઇલથી શોધો...",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noData: "કોઈ મતદાર મળ્યા નથી",

            fatherHusband: "પિતા/પતિ :",
            serialNumber: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCard: "ઓળખ કાર્ડ :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLocation: "મતદાન સ્થળ :",
            note: "નોંધ :",
            n_a: "N/A",

            filterByStatus: "સ્થિતિ દ્વારા ફિલ્ટર કરો",
            allStatuses: "બધા",
            positive: "હકારાત્મક",
            negative: "નકારાત્મક",
            doubtful: "શંકાસ્પદ",
            cantSay: "કહી શકતો નથી",
            notReceived: "પ્રાપ્ત થયું નથી",
            wrongMobile: "ખોટો મોબાઈલ",

            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિંટ",
            family: "કુટુંબ",
            address: "સરનામું",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"

        }
    };

    const txt = t[lang];
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };



    // --- Formatter to make display date prettier (30,MAR,2026 -> 30 Mar, 2026) ---
    const displayDate = passedDate ? passedDate.replace(/,/g, ' ') : "";

    // --- API Fetch Logic ---
    const fetchVoters = async () => {
        if (!appId || !passedDate) return;

        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_date_wise_survey_voter_for_call_center`,
                {
                    app_id: appId,
                    date: passedDate
                }
            );

            if (response.data.success && response.data.data && Array.isArray(response.data.data.result)) {
                setVoters(response.data.data.result);
            } else {
                setVoters([]);
            }
        } catch (error) {
            console.error("Error fetching surveyed voters by date:", error);
            setVoters([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!passedDate) {
            navigate(-1);
        } else {
            fetchVoters();
        }
    }, [appId, passedDate]);

    // --- Filter Logic ---
    const filteredVoters = voters.filter((voter) => {
        // Text Search
        let matchesSearch = true;
        if (searchTerm) {
            const lowerSearch = searchTerm.toLowerCase();
            const fullName = `${voter.eng_f_name} ${voter.eng_surname}`.toLowerCase();
            matchesSearch = fullName.includes(lowerSearch) || String(voter.contact_no).includes(lowerSearch);
        }

        // Status Filter
        let matchesStatus = true;
        if (statusFilter !== "ALL") {
            matchesStatus = String(voter.voter_status || "").toLowerCase() === statusFilter;
        }

        return matchesSearch && matchesStatus;
    });

    // --- Pagination Math ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // Get filter button label
    const getFilterButtonLabel = () => {
        if (statusFilter === 'ALL') return txt.allStatuses;
        const statusMap = {
            'p': txt.positive,
            'n': txt.negative,
            'd': txt.doubtful,
            'c': txt.cantSay,
            'nr': txt.notReceived,
            'wm': txt.wrongMobile
        };
        return statusMap[statusFilter] || txt.allStatuses;
    };

    // Helper for Status Badge Configuration
    const getStatusConfig = (statusCode) => {
        const s = String(statusCode || "").toLowerCase();
        switch (s) {
            case 'p': return { label: txt.positive, className: 'status-p' };
            case 'n': return { label: txt.negative, className: 'status-n' };
            case 'd': return { label: txt.doubtful, className: 'status-d' };
            case 'c': return { label: txt.cantSay, className: 'status-c' };
            case 'nr': return { label: txt.notReceived, className: 'status-nr' };
            case 'wm': return { label: txt.wrongMobile, className: 'status-wm' };
            default: return { label: statusCode || "N/A", className: 'status-default' };
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdown && !event.target.closest('.filter-dropdown-container')) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [showDropdown]);

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    return (
        <div className='app-container p-4'>

            {/* Header */}
            <Header title={txt.pageTitle} />

            {/* Subtitle / Context indicator */}
            <div className="subtitle-container mb-4 mt-3">
                <p className="subtitle-text">
                    <strong>{txt.subtitlePrefix}</strong> {displayDate}
                </p>
            </div>

            {/* --- PROFESSIONAL SEARCH BAR WITH FILTER DROPDOWN --- */}
            <div className="filter-container-modern mb-4">
                <div className="search-wrapper-modern">
                    <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        className="search-input-modern"
                        type="text"
                        placeholder={txt.searchPlaceholder}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                    {searchTerm && (
                        <button className="clear-search-btn" onClick={() => setSearchTerm('')}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    )}
                </div>

                {/* Filter Dropdown Button */}
                <div className="filter-dropdown-container">
                    <button
                        className="filter-dropdown-btn"
                        onClick={() => setShowDropdown(!showDropdown)}
                    >
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                        </svg>
                        <span>{txt.filterByStatus}</span>
                        <span className="filter-active-badge">{getFilterButtonLabel()}</span>
                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className={`dropdown-arrow ${showDropdown ? 'open' : ''}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    {showDropdown && (
                        <div className="filter-dropdown-menu">
                            <div
                                className={`filter-option ${statusFilter === 'ALL' ? 'active' : ''}`}
                                onClick={() => { setStatusFilter('ALL'); setShowDropdown(false); setCurrentPage(1); }}
                            >
                                <span className="filter-option-dot" style={{ backgroundColor: '#64748b' }}></span>
                                <span>{txt.allStatuses}</span>
                                {statusFilter === 'ALL' && <span className="filter-check">✓</span>}
                            </div>
                            <div
                                className={`filter-option ${statusFilter === 'p' ? 'active' : ''}`}
                                onClick={() => { setStatusFilter('p'); setShowDropdown(false); setCurrentPage(1); }}
                            >
                                <span className="filter-option-dot" style={{ backgroundColor: '#10b981' }}></span>
                                <span>{txt.positive}</span>
                                {statusFilter === 'p' && <span className="filter-check">✓</span>}
                            </div>
                            <div
                                className={`filter-option ${statusFilter === 'n' ? 'active' : ''}`}
                                onClick={() => { setStatusFilter('n'); setShowDropdown(false); setCurrentPage(1); }}
                            >
                                <span className="filter-option-dot" style={{ backgroundColor: '#ef4444' }}></span>
                                <span>{txt.negative}</span>
                                {statusFilter === 'n' && <span className="filter-check">✓</span>}
                            </div>
                            <div
                                className={`filter-option ${statusFilter === 'd' ? 'active' : ''}`}
                                onClick={() => { setStatusFilter('d'); setShowDropdown(false); setCurrentPage(1); }}
                            >
                                <span className="filter-option-dot" style={{ backgroundColor: '#f59e0b' }}></span>
                                <span>{txt.doubtful}</span>
                                {statusFilter === 'd' && <span className="filter-check">✓</span>}
                            </div>
                            <div
                                className={`filter-option ${statusFilter === 'c' ? 'active' : ''}`}
                                onClick={() => { setStatusFilter('c'); setShowDropdown(false); setCurrentPage(1); }}
                            >
                                <span className="filter-option-dot" style={{ backgroundColor: '#6366f1' }}></span>
                                <span>{txt.cantSay}</span>
                                {statusFilter === 'c' && <span className="filter-check">✓</span>}
                            </div>
                            <div
                                className={`filter-option ${statusFilter === 'nr' ? 'active' : ''}`}
                                onClick={() => { setStatusFilter('nr'); setShowDropdown(false); setCurrentPage(1); }}
                            >
                                <span className="filter-option-dot" style={{ backgroundColor: '#64748b' }}></span>
                                <span>{txt.notReceived}</span>
                                {statusFilter === 'nr' && <span className="filter-check">✓</span>}
                            </div>
                            <div
                                className={`filter-option ${statusFilter === 'wm' ? 'active' : ''}`}
                                onClick={() => { setStatusFilter('wm'); setShowDropdown(false); setCurrentPage(1); }}
                            >
                                <span className="filter-option-dot" style={{ backgroundColor: '#64748b' }}></span>
                                <span>{txt.wrongMobile}</span>
                                {statusFilter === 'wm' && <span className="filter-check">✓</span>}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* --- Loading State --- */}
            {loading && (
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loadingData}</p>
                </div>
            )}

            {/* No Data State */}
            {!loading && filteredVoters.length === 0 && (
                <div className="row mt-3">
                    <div className="col-12 text-center text-muted p-5 empty-state">
                        <div className="empty-icon">👥</div>
                        <p>{txt.noData} {searchTerm && `"${searchTerm}"`}</p>
                    </div>
                </div>
            )}

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* --- Results Grid --- */}
            <div className="row g-4 mt-1 pb-5">
                {!loading && currentItems.map((voter, index) => {
                    const statusObj = getStatusConfig(voter.voter_status);
                    // Filter out "-" from names
                    const fName = voter.eng_f_name && voter.eng_f_name !== '-' ? voter.eng_f_name : '';
                    const sName = voter.eng_surname && voter.eng_surname !== '-' ? voter.eng_surname : '';
                    const fullName = `${fName} ${sName}`.trim();

                    return (
                        <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                            <div className="voter-card-clean h-100">

                                {/* Header with Status Badge */}
                                <div className="voter-header d-flex justify-content-between align-items-start">
                                    <div>
                                        <span className="serial-number">{voter.slnoinpart || (index + 1 + indexOfFirstItem)}.</span>
                                        <span className="voter-name-bold ms-2">{fullName || "Unknown Name"}</span>
                                    </div>
                                    <span className={`status-pill ${statusObj.className}`}>
                                        {statusObj.label}
                                    </span>
                                </div>

                                {/* Body Information */}
                                <div className="voter-body position-relative mt-3">
                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name && voter.eng_m_name !== '-' ? voter.eng_m_name : txt.n_a}</span></div>
                                    <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                    <div className="info-row"><span className="label">{txt.serialNumber}</span><span className="value">{voter.slnoinpart}</span></div>
                                    <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className="label">{txt.mobile}</span>
                                        <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                        <svg
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setEditingVoter(voter);
                                                setNewMobile(voter.contact_no || '');
                                                setIsEditMobileOpen(true);
                                            }}
                                            style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                            fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                        </svg>
                                    </div>
                                    <div className="info-row"><span className="label">{txt.idCard}</span><span className="value">{voter.idcard_no || txt.n_a}</span></div>
                                    <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || txt.n_a}</span></div>
                                    <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || txt.n_a}</span></div>
                                    <div className="info-row"><span className="label">{txt.pollingLocation}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>

                                    {voter.note && (
                                        <div className="info-row mt-2 p-2 bg-light rounded border"><span className="label">{txt.note}</span><span className="value text-muted">{voter.note}</span></div>
                                    )}
                                </div>

                                {/* Action Buttons */}
                                <div className="voter-actions mt-auto pt-3 border-top">
                                    <ActionButton icon={voterIcons.call} color={VOTER_ORANGE} label={txt.call}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                alert("Mobile number is not available for this voter.");
                                            }
                                            else {
                                                window.open(`tel:${voter.contact_no}`, '_blank');
                                            }
                                        }}

                                    />
                                    <ActionButton icon={voterIcons.text} color={VOTER_ORANGE} label={txt.text} onClick={() => handleSmsShare(voter)} />
                                    {/* નવો કોડ */}
                                    <WhatsappSlipButton voter={voter} />
                                    {/* નોંધ: જો map માં વેરીએબલ નું નામ member હોય, તો voter={member} પાસ કરજો */}
                                    <PracharButton voter={voter} />
                                    <ActionButton icon={voterIcons.print} color={VOTER_ORANGE} label={txt.print} onClick={() => navigate('/printer', { state: { voter_id: voter.id } })} />
                                    <ActionButton icon={voterIcons.family} color={VOTER_ORANGE} label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                </div>

                            </div>
                        </div>
                    );
                })}
            </div>

            {/* --- PAGINATION CONTROLS --- */}
            {!loading && filteredVoters.length > itemsPerPage && (
                <div className="pagination-wrapper">
                    <div className="pagination-content">
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                        </button>
                        <div className="page-numbers">
                            {getPageNumbers().map((number, index) => (
                                <React.Fragment key={index}>
                                    {number === '...' ? (<span className="page-dots">...</span>) : (
                                        <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                        </button>
                    </div>
                </div>
            )}

            <style jsx>{`
                .app-container {
                    background: #E5E7EB;
                    min-height: 100vh;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                }

                /* Subtitle Styles */
                .subtitle-container { margin-top: 8px; margin-bottom: 20px; position: relative; }
                .subtitle-text { font-size: 15px; color: #334155; margin: 0 0 10px 0; font-weight: 600; }
                .subtitle-container::after { content: ""; display: block; width: 60px; height: 3px; background: linear-gradient(to right, #2563eb, #60a5fa); border-radius: 3px; margin-top: 4px; }

                /* --- SEARCH BAR WITH FILTER STYLES --- */
                .filter-container-modern { 
                    display: flex; 
                    justify-content: space-between; 
                    align-items: center; 
                    gap: 16px;
                    flex-wrap: wrap;
                    margin-bottom: 20px;
                }
                .search-wrapper-modern { 
                    position: relative; 
                    flex: 1;
                    max-width: 450px;
                }
                .search-icon-modern { 
                    position: absolute; 
                    left: 14px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    width: 20px; 
                    height: 20px; 
                    color: #94a3b8; 
                    pointer-events: none; 
                    z-index: 1; 
                }
                .search-input-modern { 
                    width: 100%; 
                    padding: 12px 16px 12px 42px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 12px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    background-color: #ffffff; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                }
                .search-input-modern:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }
                .clear-search-btn {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #f1f5f9;
                    border: none;
                    border-radius: 50%;
                    padding: 6px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #64748b;
                    transition: all 0.2s;
                }
                .clear-search-btn:hover {
                    background: #e2e8f0;
                }

                /* Filter Dropdown Styles */
                .filter-dropdown-container {
                    position: relative;
                }
                .filter-dropdown-btn {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 500;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                }
                .filter-dropdown-btn:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                }
                .filter-active-badge {
                    background: #e2e8f0;
                    padding: 2px 8px;
                    border-radius: 20px;
                    font-size: 11px;
                    font-weight: 600;
                    color: #475569;
                }
                .dropdown-arrow {
                    transition: transform 0.2s ease;
                }
                .dropdown-arrow.open {
                    transform: rotate(180deg);
                }
                .filter-dropdown-menu {
                    position: absolute;
                    top: calc(100% + 8px);
                    right: 0;
                    min-width: 210px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                    z-index: 100;
                    overflow: hidden;
                }
                .filter-option {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 16px;
                    cursor: pointer;
                    transition: background 0.2s ease;
                    font-size: 14px;
                    color: #1e293b;
                }
                .filter-option:hover {
                    background: #f8fafc;
                }
                .filter-option.active {
                    background: #eff6ff;
                }
                .filter-option-dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                }
                .filter-check {
                    margin-left: auto;
                    color: #10b981;
                    font-weight: bold;
                }

                /* Status Pills */
                .status-pill {
                    padding: 4px 10px;
                    border-radius: 20px;
                    font-size: 11px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                .status-p { background-color: #dcfce7; color: #166534; border: 1px solid #bbf7d0; }
                .status-n { background-color: #fee2e2; color: #991b1b; border: 1px solid #fecaca; }
                .status-d { background-color: #fef3c7; color: #b45309; border: 1px solid #fde68a; }
                .status-c { background-color: #e0e7ff; color: #3730a3; border: 1px solid #c7d2fe; }
                .status-nr { background-color: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; }
                .status-wm { background-color: #e2e8f0; color: #334155; border: 1px solid #cbd5e1; }
                .status-default { background-color: #f8fafc; color: #94a3b8; border: 1px solid #f1f5f9; }
                
                .empty-state { background: white; border-radius: 20px; border: 2px dashed #e2e8f0; }
                .empty-icon { font-size: 3rem; margin-bottom: 10px; opacity: 0.5; }

                /* Loading specific overrides */
                .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 40vh; width: 100%; }
                .spinner { width: 40px; height: 40px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 12px; }
                .loader-text { color: #6B7280; font-weight: 500; }
                
                /* Pagination Styles */
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; position: sticky; bottom: 20px; z-index: 50; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 6px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
                .pagination-nav-btn { display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; background: transparent; border: none; color: #2563EB; cursor: pointer; }
                .pagination-nav-btn:disabled { color: #CBD5E1; cursor: not-allowed; }
                .page-numbers { display: flex; gap: 4px; align-items: center; }
                .page-num-btn { width: 30px; height: 30px; border-radius: 50%; border: none; background: transparent; color: #475569; font-weight: 600; font-size: 13px; cursor: pointer; }
                .page-num-btn.active { background-color: #2563EB; color: white; }

                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

                @media (max-width: 640px) {
                    .search-wrapper-modern { 
                        max-width: 100%;
                        flex: none;
                        width: 100%;
                    }
                    .filter-container-modern {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .filter-dropdown-btn {
                        justify-content: center;
                        width: 100%;
                    }
                    .filter-dropdown-menu {
                        right: auto;
                        left: 0;
                        width: 100%;
                    }
                    .voter-actions { gap: 6px; }
                    .circle-btn { width: 32px; height: 32px; font-size: 14px; }
                    .btn-label { font-size: 9px; }
                }
            `}</style>
        </div>
    );
};

// Reusable ActionButton
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default DateWiseCallCenterSurveyMember;